import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const Ark: Dashboard = {
    id: 'ARK',
    name: 'Ark',
    daterange: true,
    metrics: [
        {
            type: Metrics.ARK_TOP_STORES,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.ARK_DWELL_TIME_SKU,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-dwelltime',
            count: 'dashboard-count-products',
            'count-data': 'dashboard-count-time',
        },
        {
            type: Metrics.ARK_BUTTONS,
            'box-size': BoxSizes.BIG,
            chart: Chart.Bars,
            title: 'dashboard-buttons',
            count: 'dashboard-count-touches',
        },
        {
            type: Metrics.ARK_SESSIONS_SKU,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-sessions',
            count: 'dashboard-count-products',
            'count-data': 'dashboard-count-sessions',
        },
        {
            type: Metrics.ARK_NO_INTERACTIONS_SKU,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-no-interactions',
            count: 'dashboard-count-products',
        },
    ],
}

export default Ark
